import React, { useEffect, useState ,useRef} from "react";
import { Card, Grid, Box, Typography, Button } from "@mui/material";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import EducationJobForm from "../Authentication/EducationJobForm";
import { matrimoneyEndPoints } from "../../../services/apis";
import axios from "axios";

const EducationView = (props) => {
  const [open, setOpen] = useState(false);
  const [educationalData,setEducationDetails] = useState(props.educationalData)
  let getMyProfileData = localStorage.getItem("profileData")
  let MyProfileData = JSON.parse(getMyProfileData)
  let userType = sessionStorage.getItem("userType")
    let apiCall = useRef(false)
   const getCustomerData = async () => {
      try {
        let userType = sessionStorage.getItem("userType")
    let token
    if(userType){
      token = sessionStorage.getItem("token");
    }else{
       token = localStorage.getItem("token");
    }
        const response = await axios.post(
          matrimoneyEndPoints.VIEW_CUSTOMER_DETAILS,
          { profileId: props?.profileId},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response.data.status) {
          setEducationDetails(response?.data?.data)
        }
      } catch (error) {
        console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
      } 
    };
  // useEffect(()=>{
  //   getCustomerData()
  // },[open])
  useEffect(() => {
      if (!apiCall.current) {
        apiCall.current = true
        getCustomerData();
      }
    }, []);
  if (!props?.educationalData) {
    return <p>No profile data available.</p>;
  }

  const renderSection = (sectionTitle, sectionData) => (
    <Card
      sx={{
        padding: "10px 50px",
        mb: "20px",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        border: "3px solid rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography sx={{ ...styles.viewtextstyle }}>{sectionTitle}</Typography>
      <Grid container spacing={2}>
        {Object.entries(sectionData).map(([label, value], index) => (
          <Grid
            item
            xs={12}
            sm={6}
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 3,
              py: 1.5,
               borderBottom: "2px dotted #ccc", 
            }}
          >
            <Typography
              variant="body1"
              fontWeight="bold"
              sx={{ textAlign: "start", color: "#333", fontSize: "18px" }}
            >
              {label}
            </Typography>
            <Typography
              variant="body1"
              sx={{ textAlign: "end", color: "#555", maxWidth: "60%" }}
            >
              {Array.isArray(value)
                ? value.length > 0
                  ? value.join(", ")
                  : "--"
                : value || "--"}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Card>
  );

  return (
    <Box>
      <Box>
        <Box
          sx={{
            display: "flex",
justifyContent: "flex-end",
            marginBottom: "10px",
          }}
        >
          {/* <Typography
            sx={{
              fontFamily: '"Roboto Condensed", sans-serif',
              fontWeight: 600,
              fontSize: "24px",
              letterSpacing: "0%",
            }}
          >
            Education & Profession Details
          </Typography> */}

          {((MyProfileData && MyProfileData.id == props?.profileId) || userType) &&<Button
            variant="contained"
            onClick={() => setOpen(!open)}
            sx={{
              backgroundColor: "#C1721F",
              color: "white",
              display: "flex",
              alignItems: "right",
              gap: "5px",
            }}
          >
            {open ? "View" : "Edit"}
          </Button>}
        </Box>

        {!open ? (
          <Card
            sx={{
              ...styles.cardeducation,
              height: { xs: "auto", sm: "auto" },
              padding: { xs: 2, sm: 4 },
              borderRadius: "5px",
            }}
          >
            <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
            <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
            <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
            <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
            <Box
              sx={{
                width: "100%",
                margin: "auto",
                backgroundColor: "white",
                border: "2px solid #C1721F",
                padding: { xs: "10px", sm: "50px 50px" },
                borderRadius: "10px",
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Education Details Section */}
              {renderSection("Education Details", educationalData["Education Details"] || {})}

              {/* Profession Details Section */}
              {renderSection("Profession Details", educationalData["Profession Details"] || {})}
            </Box>
          </Card>
        ) : (
          <Box sx={{ width: { xs: "auto", sm: "800px", md: "1405px" }, margin: "auto" }}>
            <EducationJobForm 
            type="edit"
            onSubmitSuccess={() => setOpen(false)}  />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default EducationView;
